import React from "react";
import AnalyzePage from "../../Components/AnalyzePage/Analyze";

export default function Home() {
  return <AnalyzePage />;
}
